import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {FilterBarModuleConfig} from "./filter-bar-module.config";
import {FilterBarModuleStore} from "./filter-bar-module.store";
import {FilterBarModuleHandlers} from "./handlers/filter-bar-module.handlers";

export class FilterBarModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  FilterBarModuleConfig, FilterBarModuleStore, FilterBarModuleHandlers];

}
